import * as React from 'react';
export const chevronRightCircleSvg = React.forwardRef(
  function chevronRightCircleSvgInner(props, ref) {
    return /*#__PURE__*/ React.createElement(
      'svg',
      {
        ...props,
        ref: ref,
      },
      /*#__PURE__*/ React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M6.22 12.28a.75.75 0 0 1 0-1.06L9.44 8 6.22 4.78a.75.75 0 0 1 1.06-1.06l3.75 3.75a.75.75 0 0 1 0 1.06l-3.75 3.75a.75.75 0 0 1-1.06 0Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M14.5 8A6.5 6.5 0 0 0 8 1.5C4.408 1.5 1.5 4.4 1.5 8A6.5 6.5 0 0 0 8 14.5 6.5 6.5 0 0 0 14.5 8ZM16 8a8 8 0 0 0-8-8C3.581 0 0 3.57 0 8a8 8 0 0 0 8 8 8 8 0 0 0 8-8Z',
      }),
    );
  },
);
chevronRightCircleSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var chevronRightCircle = {
  category: 'icon',
  colorable: true,
  name: 'chevronRightCircle',
  svg: chevronRightCircleSvg,
};
